<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
    <v-col cols="2">
      <v-card class="mt-2">
        <v-toolbar color="primary" flat dark dense>
          <v-toolbar-title class="ml-2">Search</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            ref="search"
            v-model="searchTerm"
            prepend-icon="mdi-magnify"
            persistent-hint
            hint="Search by Name, Email, Vin or Phone"
            single-line
            clearable
            :disabled="searchRunning"
            @keydown.native.escape="searchTerm=''"
            @keydown.native.enter="doSearch"
          >
          </v-text-field>

          <v-sheet
            v-show="searchRunning"
            color="grey lighten-4"
            class="px-3 pt-3 pb-3"
          >
            <v-skeleton-loader
              class="mx-auto"
              :type="listLoaderSkeleton"
            ></v-skeleton-loader>
          </v-sheet>

          <v-list dense o-line v-show="!searchRunning" class="v-list-scroll">
             <v-list-item
              v-for="(item, itemIdx) in searchResults"
              :key="item.search_value + item.customer_id + itemIdx"
              @click="showDetails(item)"
            >
               <v-list-item-content>
                 <v-list-item-title v-text="item.search_value"></v-list-item-title>
                 <v-list-item-subtitle>
                  {{item.customer_name}} <v-chip small>{{item.customer_last_visit}}</v-chip>
                 </v-list-item-subtitle>
               </v-list-item-content>
             </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="10">
      <omni-search-show v-model="selectedCustomerId"/>
    </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { OmniSearchApi } from '@/services'
import OmniSearchShow from './OmniSearchShow'

export default {
  components: {
    [OmniSearchShow.name]: OmniSearchShow
  },
  data: function () {
    return {
      searchTerm: '',
      searchResults: [],
      searchRunning: false,
      selectedCustomerId: null,
      listLoaderSkeleton: Array(10).fill('list-item').join(',')
    }
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' })
  },
  watch: {
    searchTerm (newVal) {
      if (!newVal) {
        this.searchResults = []
        this.selectedCustomerId = null
      }
    },
    dealer (newVal) {
      this.resetSearch()
    }
  },
  methods: {
    resetSearch () {
      this.searchResults = []
      this.selectedCustomerId = null
    },
    showDetails (searchItem) {
      this.selectedCustomerId = searchItem.customer_id
    },
    async doSearch () {
      this.searchRunning = true
      try {
        if (this.searchTerm) {
          const resp = await OmniSearchApi.search(this.dealer.id, this.searchTerm)
          this.searchResults = resp.data
        } else {
          this.$refs.search.focus()
        }
      } catch (error) {
        return 'TODO'
      } finally {
        this.searchRunning = false
      }
    }
  },
  mounted: function () {
    this.$refs.search.focus()
  }
}
</script>

<style>
.v-list-scroll {
    height:auto;
    max-height:76vh;
    overflow:auto;
}
</style>
